import { parsePhoneNumberWithError, ParseError } from '@doordash/utilities';
import { getInvalidPhoneNumber } from './getInvalidPhoneNumber.js';

/**
 * Transforms a LibPhoneNumber object to our own PhoneNumber object
 */

var libPhoneNumberToIntlPhoneFieldPhoneNumber = function libPhoneNumberToIntlPhoneFieldPhoneNumber(libPhoneNumber) {
  return {
    number: libPhoneNumber.number,
    countryCode: libPhoneNumber.country,
    isPossible: libPhoneNumber.isPossible(),
    isValid: libPhoneNumber.isValid(),
    type: libPhoneNumber.getType(),
    countryCallingCode: libPhoneNumber.countryCallingCode,
    ext: libPhoneNumber.ext,
    nationalNumber: libPhoneNumber.nationalNumber,
    carrierCode: libPhoneNumber.carrierCode
  };
};
/**
 * Parse a given E.164 format compliant input phone number, to return a
 * PhoneNumber object.
 */


var parsePhoneNumber = function parsePhoneNumber(input, countryCode) {
  var parsed = getInvalidPhoneNumber(input, countryCode);

  try {
    parsed = libPhoneNumberToIntlPhoneFieldPhoneNumber(parsePhoneNumberWithError(input, countryCode));
  } catch (e) {
    if (e instanceof ParseError) {
      parsed.invalidReason = e.message;
    } else {
      throw e;
    }
  }

  if (!parsed.isValid && !parsed.invalidReason) {
    parsed.invalidReason = 'UNSPECIFIED';
  }

  return parsed;
};

export { parsePhoneNumber };
